import { useEffect } from 'react';
/**
 * Prevents scrolling gestures on a given element primarily for the use
 * on overlays or modals on IOS Safari and touch devices
 *
 * This hook blocks `touchmove` events with
 * `preventDefault()` and `{ passive: false }` to ensure the browser
 * does not perform its native scroll or bounce behaviors.
 *
 * @param ref - React HTMLElement ref pointing to the element to lock touch scroll on
 * @param enabled - boolean value signaling that consumer wants to OPT in to use, defaulted to true
 *
 * @example
 * const overlayRef = useRef<HTMLDivElement>(null)
 * usePreventTouchScroll(overlayRef);
 */
export const usePreventTouchScroll = ({ ref, enabled = true }) => {
    useEffect(() => {
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!el || !enabled)
            return;
        const preventTouchScroll = (e) => e.preventDefault();
        // Passive needs to be false for IOS and Safari to actually prevent the default
        el.addEventListener('touchmove', preventTouchScroll, { passive: false });
        // eslint-disable-next-line consistent-return
        return () => {
            el.removeEventListener('touchmove', preventTouchScroll);
        };
    }, [ref, enabled]);
};
//# sourceMappingURL=usePreventTouchScroll.js.map